<template>
    <div class="ag-dropdown-menu" ref="dropdownMenu" @mouseleave="onMouseLeave($event)" @mouseover="onMouseOver($event)">
        <div class="dropdown-target" ref="target">
            <slot></slot>
        </div>
        <transition>
            <div class="dropdown-menu" v-if="isOpen" ref="popover"
                 :style="{'margin-top': (verticalOffset) ? verticalOffset + 'px' : '0px', 'margin-left': (horizontalOffset) ? horizontalOffset + 'px' : '0px'}">
                <slot name="header">
                    <h3 style="font-size: 14px; padding: 10px 12px;" v-if="user">{{ user.name }}</h3>
                </slot>
                <slot name="body">
                    <ul>
                        <li v-if="user.isMaster" @click="redirectUserMaster()" style="margin-bottom: 10px;">{{ currentRoutePath.indexOf('/master') === -1 ? 'MASTER' : 'DASHBOARD' }}</li>
                        <!-- <li v-if="user.isMaster" @click="goToMaster()">{{ $route.name.indexOf('/master') === -1 ? 'MASTER' : 'DAHSBOARD' }}</li> -->
                        <li v-for="company of companies" :key="company.id"
                            :class="{ 'company-selected': user.defaultCompanyId === company.id }"
                            @click="selectCompany(company.id)"
                        >{{ company.name }}</li>
                        <li @click="logout()" style="margin-top: 10px;">Sair</li>
                    </ul>
                </slot>
            </div>
        </transition>
    </div>
</template>
<script>
    import Vue from 'vue';
    import Popper from 'popper.js';

    export default {
        data(){
            return {
                popperInstance: null,
                isOpen: false,
                closeTimeout: null
            }
        },
        props: ['params', 'closeOnSelect', 'companies', 'placement', 'verticalOffset', 'horizontalOffset', 'user'],
        computed: {
            currentRoutePath() {
                return this.$route.path
            }
        },
        methods: {
            redirectUserMaster() {
                let path = this.currentRoutePath.indexOf('/master') === -1 
                    ? '/master/company-request-monitoring' 
                    : '/dashboard'
                this.$router.replace(path)
                setTimeout(() => window.location.reload(), 1000)
            },
            selectCompany(companyId) {
                this.$emit('selectCompany', companyId)
            },
            onMouseOver(){
                if(this.closeTimeout){
                    clearTimeout(this.closeTimeout);
                }
            },
            onMouseLeave(){
                this.closeTimeout = setTimeout(() => {
                    this.closeSelect();
                }, 1200);
            },
            onClick(ev){
                const vm = this;
                if(vm.isOpen && vm.$refs.popover && (vm.$refs.popover !== ev.target && !vm.$refs.popover.contains(ev.target))){
                    vm.closeSelect();
                }
                else if(!vm.isOpen && vm.$refs.target.contains(ev.target)){
                    vm.openSelect();
                }
            },
            async openSelect(){
                this.isOpen = true
                await Vue.nextTick()
                if(this.popperInstance) {
                    this.popperInstance.destroy();
                }
                this.popperInstance = new Popper(this.$refs.target, this.$refs.popover, {
                    placement: (!this.placement) ? 'bottom-start' : this.placement
                })
            },
            closeSelect(){
                this.isOpen = false;
            },
            toggleSelect(){
                if(this.isOpen) return this.closeSelect();
                this.openSelect();
            },
            logout() {
                this.$emit('logout')
            }
        },
        mounted(){
            document.addEventListener('mousedown', this.onClick);
        },
        beforeDestroy(){
            document.removeEventListener("mousedown", this.onClick);
        }


    }
</script>

<style scoped>

div.ag-dropdown-menu {
    display:flex;
    justify-content: flex-end;
    flex-direction: row;
}

div.dropdown-menu {
    position: absolute;
    z-index: 99999;
    background: var(--bg-color);
    text-align: left;
    align-self: center;
    box-shadow: var(--popover-shadow);
    min-width: 200px;
}

.v-enter-active, .v-leave-active {
    transition: opacity .1s
}
.v-enter, .v-leave-to {
    opacity: 0;
}

div.dropdown-target {
    cursor: pointer;
    display: flex;
}

div.dropdown-menu li {
    padding: 8px 12px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    color: var(--font-color--8);
    cursor: pointer;
}

div.dropdown-menu li:hover {
    background: var(--bg-color--7);
}

div.dropdown-menu li:last-child {
    border-bottom: 0;
}

.company-selected {
    background: linear-gradient(89.39deg, #0072E4 -0.59%, #25A0A8 100.95%);
    font-weight: 600;
}


</style>
